export default __webpack_public_path__ + "static/media/play-circle.ebd15b6a.svg";